module.exports = __webpack_public_path__ + "img/folder-heart.c98ba88d.svg";